export const addNoScroll = (preventDefault) => {
  document.body.classList.add('overflow-hidden');
  document.body.addEventListener('touchmove', preventDefault, { passive: false });
};

export const removeNoScroll = (preventDefault) => {
  document.body.classList.remove('overflow-hidden');
  document.body.removeEventListener('touchmove', preventDefault);
};
